import { CustomFormattedMessage, TranslationsKeys } from '../i18n/i18n';
import RioNotification from '@rio-cloud/rio-uikit/lib/es/Notification';
import { ReactNode } from 'react';

export const GRAPHQL_ERROR_TITLE_KEY: TranslationsKeys =
  'base.body.notificationBanner.graphqlFailureTitle';
export const GRAPHQL_ERROR_MESSAGE_KEY: TranslationsKeys =
  'base.body.notificationBanner.graphqlFailureMessage';

export const GRAPHQL_SUBSCRIPTION_ERROR_TITLE_KEY: TranslationsKeys =
  'base.body.notificationBanner.graphqlSubscriptionFailureTitle';
export const GRAPHQL_SUBSCRIPTION_ERROR_MESSAGE_KEY: TranslationsKeys =
  'base.body.notificationBanner.graphqlSubscriptionFailureMessage';

const NOTIFICATION_TIMEOUT = 999999;

export const notifyDismissible = (
  type: keyof typeof RioNotification,
  body: ReactNode,
  title?: TranslationsKeys,
) => {
  RioNotification[type](
    <span data-testid="dismissible-info-notification">
      {body}
      <span className="notification-close">
        <span className="rioglyph rioglyph-remove" />
      </span>
    </span>,
    title
      ? {
          title: <CustomFormattedMessage id={title} />,
        }
      : undefined,
    NOTIFICATION_TIMEOUT,
  );
};
